'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
* hashtag_module.js
* http://www.codrops.com
*
* Licensed under the MIT license.
* http://www.opensource.org/licenses/mit-license.php
* 
* Copyright 2019, Codrops
* http://www.codrops.com
*/
document.addEventListener("DOMContentLoaded", function () {
    // {
    if (document.querySelector('.home-module.social-module')) {
        var mousePos;
            setTimeout(function () {
                    // body element
                    var body = document.querySelector('#hashtag_module_frame');
    
                    // helper functions
                    var MathUtils = {
                        // linear interpolation
                        lerp: function lerp(a, b, n) {
                            return (1 - n) * a + n * b;
                        },
                        // distance between two points
                        distance: function distance(x1, y1, x2, y2) {
                            return Math.hypot(x2 - x1, y2 - y1);
                        }
                    };
    
                    // get the mouse position
                    var getMousePos = function getMousePos(ev) {
                        var posx = 0;
                        var posy = 0;
                        if (!ev) ev = document.querySelector('#hashtag_module_frame .content').event;
                        if (false) {
                            posx = ev.pageX;
                            posy = ev.pageY;
                        } else if (ev.clientX || ev.clientY) {
                            posx = ev.clientX;
                            posy = ev.offsetY;
                        }
                        return { x: posx, y: posy };
                    };
    
                    // mousePos: current mouse position
                    // cacheMousePos: previous mouse position
                    // lastMousePos: last last recorded mouse position (at the time the last image was shown)
                    mousePos = lastMousePos = cacheMousePos = { x: 0, y: 0 };
    
                    // update the mouse position
    
                    document.querySelector('#hashtag_module_frame .content').addEventListener('mousemove', function (ev) {
                        return mousePos = getMousePos(ev);
                    });

                    // gets the distance from the current mouse position to the last recorded mouse position
                    var getMouseDistance = function getMouseDistance() {
                        return MathUtils.distance(mousePos.x, mousePos.y, lastMousePos.x, lastMousePos.y);
                    };
    
                    var Image = function () {
                        function Image(el) {
                            _classCallCheck(this, Image);
    
                            this.DOM = { el: el };
                            // image deafult styles
                            this.defaultStyle = {
                                scale: 1,
                                x: 0,
                                y: 0,
                                opacity: 0
                            };
                            // get sizes/position
                            this.getRect();
                            // init/bind events
                            this.initEvents();
                        }
    
                        _createClass(Image, [{
                            key: 'initEvents',
                            value: function initEvents() {
                                var _this = this;
    
                                // on resize get updated sizes/position
                                window.addEventListener('resize', function () {
                                    return _this.resize();
                                });
                            }
                        }, {
                            key: 'resize',
                            value: function resize() {
                                // reset styles
                                TweenMax.set(this.DOM.el, this.defaultStyle);
                                // get sizes/position
                                this.getRect();
                            }
                        }, {
                            key: 'getRect',
                            value: function getRect() {
                                this.rect = this.DOM.el.getBoundingClientRect();
                            }
                        }, {
                            key: 'isActive',
                            value: function isActive() {
                                // check if image is animating or if it's visible
                                return TweenMax.isTweening(this.DOM.el) || this.DOM.el.style.opacity != 0;
                            }
                        }]);
    
                        return Image;
                    }();
    
                    var ImageTrail = function () {
                        function ImageTrail() {
                            var _this2 = this;
    
                            _classCallCheck(this, ImageTrail);
    
                            // images container
                            this.DOM = { content: document.querySelector('#hashtag_module_frame .content') };
                            // array of Image objs, one per image element
                            this.images = [];
                            [].concat(_toConsumableArray(this.DOM.content.querySelectorAll('img'))).forEach(function (img) {
                                return _this2.images.push(new Image(img));
                            });
                            // total number of images
                            this.imagesTotal = this.images.length;
                            // upcoming image index
                            this.imgPosition = 0;
                            // zIndex value to apply to the upcoming image
                            this.zIndexVal = 1;
                            // mouse distance required to show the next image
                            this.threshold = 100;
                            // render the images
                            requestAnimationFrame(function () {
                                return _this2.render();
                            });
                        }
    
                        _createClass(ImageTrail, [{
                            key: 'render',
                            value: function render() {
                                var _this3 = this;
    
                                // get distance between the current mouse position and the position of the previous image
                                var distance = getMouseDistance();
                                // cache previous mouse position
                                cacheMousePos.x = MathUtils.lerp(cacheMousePos.x || mousePos.x, mousePos.x, 0.1);
                                cacheMousePos.y = MathUtils.lerp(cacheMousePos.y || mousePos.y, mousePos.y, 0.1);
    
                                // if the mouse moved more than [this.threshold] then show the next image
                                if (distance > this.threshold) {
                                    this.showNextImage();
    
                                    ++this.zIndexVal;
                                    this.imgPosition = this.imgPosition < this.imagesTotal - 1 ? this.imgPosition + 1 : 0;
    
                                    lastMousePos = mousePos;
                                }
    
                                // check when mousemove stops and all images are inactive (not visible and not animating)
                                var isIdle = true;
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;
    
                                try {
                                    for (var _iterator = this.images[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                        var img = _step.value;
    
                                        if (img.isActive()) {
                                            isIdle = false;
                                            break;
                                        }
                                    }
                                    // reset z-index initial value
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return) {
                                            _iterator.return();
                                        }
                                    } finally {
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
    
                                if (isIdle && this.zIndexVal !== 1) {
                                    this.zIndexVal = 1;
                                }
    
                                // loop..
                                requestAnimationFrame(function () {
                                    return _this3.render();
                                });
                            }
                        }, {
                            key: 'showNextImage',
                            value: function showNextImage() {
                                // show image at position [this.imgPosition]
                                var img = this.images[this.imgPosition];
                                // kill any tween on the image
                                TweenMax.killTweensOf(img.DOM.el);
    
                                new TimelineMax()
                                    // show the image
                                    .set(img.DOM.el, {
                                        startAt: { opacity: 0, scale: 1 },
                                        opacity: 1,
                                        scale: 1,
                                        zIndex: this.zIndexVal,
                                        x: cacheMousePos.x - img.rect.width / 2,
                                        y: cacheMousePos.y - img.rect.height / 2
                                    }, 0)
                                    // animate position
                                    .to(img.DOM.el, 0.9, {
                                        ease: Expo.easeOut,
                                        x: mousePos.x - img.rect.width / 2,
                                        y: mousePos.y - img.rect.height / 2
                                    }, 0)
                                    // then make it disappear
                                    .to(img.DOM.el, 1, {
                                        ease: Power1.easeOut,
                                        opacity: 0
                                    }, 0.4)
                                    // scale down the image
                                    .to(img.DOM.el, 1, {
                                        ease: Quint.easeOut,
                                        scale: 0.2
                                    }, 0.4);
                            }
                        }]);
    
                        return ImageTrail;
                    }();
    
                    /***********************************/
                    /********** Preload stuff **********/
    
                    // Preload images
    
    
                    var preloadImages = function preloadImages() {
                        return Promise.all(
                            Array.from(document.querySelectorAll('.content__img')).map(function (img) {
                                return img.complete
                                    ? Promise.resolve()
                                    : new Promise(function (resolve) {
                                        img.addEventListener('load', resolve);
                                        img.addEventListener('error', resolve);
                                    });
                            })
                        );
                    };
    
                    // And then..
                    preloadImages().then(function () {
                        // Remove the loader
                        document.body.classList.remove('loading');
                        new ImageTrail();
                    });
            }, 1000)

    }
// }
});